<template>
  <section class="flex block__slideout block__slideout_notifications">
    <b-row class="block__notification">
      <!-- ENTETE -->
      <div class="mobile">
        <div class="link">
          <button class="bt btn-back" v-b-toggle.sidebar-notifications>
              <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h3>{{general.notificationsTitle}}</h3>
        </div>
        <div class="sep"></div>
      </div>
      <!-- ENTETE -->


      <!-- CONTENT -->
      <div class="scrollable col px-0">
        <div class="entete col">
          <h1>{{general.notificationsTitle}}</h1>
        </div>

        <div class="col">
          <b-list-group>
            <PuSkeleton :loading="isLoading" width="100%" height="100px">

            </PuSkeleton>
            <PuSkeleton :loading="isLoading" width="100%" height="100px">

            </PuSkeleton>
            <PuSkeleton :loading="isLoading" width="100%" height="100px">

            </PuSkeleton>
            <div v-for="(notificationsElements, date) in notifications" :key="date">
              <PuSkeleton :loading="isLoading" width="50%">
                <div class="date">{{ date }}</div>
              </PuSkeleton>
              <div v-for="(notif, key) in notificationsElements" :key="key">
                <b-list-group-item>
                  <CardNotification :notif="notif"></CardNotification>
                </b-list-group-item>
              </div>
            </div>
            <div v-if="notifications == null && isLoading == false">
                <div class="date">Aucunes notifications</div>
            </div>


<!--            <b-list-group-item>
              <CardNotificationContest type="positif" title="Objectif positif" ></CardNotificationContest>
            </b-list-group-item>-->
              <Stack></Stack>
          </b-list-group>
        </div>
      </div>
      <!-- CONTENT -->

    </b-row>

  </section>
</template>




<script>
import { mapGetters } from 'vuex'
import CardNotification from '../../../../components/module/card/CardNotification'
//import CardNotificationContest from '../../../../components/module/card/CardNotificationContest'
import Stack from '../../../../components/module/stack/Stack'
import ApiService from "@/services/ApiService";

export default {
    name:"notificationsHome",
    components:{ 
      CardNotification,
      //CardNotificationContest,
      Stack     
    }, 
    mixins:[
    ],
    computed: {
      ...mapGetters([
        'getGeneral',
          'getIsMobile'
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        isMobile:false,
        notifications:null
      }
    },
    created (){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      this.getData().then(() => {
        this.isLoading = false;
      })
    },    
    methods : {
      async getData(){
        await ApiService.getNotificationApi().get().then((data) => {
          this.notifications = data.data;
        })
      },
      goBack() {
        this.$router.push({name: "home"});  
      },
    },
  watch: {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
};
</script>
